import React from "react";
import Topbar from "../../Component/Topbar/Topbar";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { blue, green, orange, person, pink, red } from "../../assets/img";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
const Dashboard = () => {
  const boxData = [
    {
      title: "Super Admin",
      bgColor: "#DBF0FF",
      borderColor: "#DBF0FF",
      titleColor: "#252563",
      valueColor: "#1A77BC",
      img: blue,
      value: "04",
    },

    {
      title: "Inventory",
      bgColor: "#EAF7EC",
      borderColor: "#EAF7EC",
      fontColor: "#333333",
      valueColor: "#2E7D32",
      img: green,
      value: "04",
    },
    {
      title: "Technical",
      bgColor: "#FFF4E5",
      borderColor: "#FFF4E5",
      valueColor: "#E65100",

      fontColor: "#333333",
      img: orange,
      value: "04",
    },
    {
      title: "Service Engineer",
      bgColor: "#FFF0F3",
      borderColor: "#FFF0F3",
      valueColor: "#C62828",

      fontColor: "#333333",
      img: red,
      value: "04",
    },
    {
      title: "Regional Manager",
      bgColor: "#E8EAF6",
      borderColor: "#E8EAF6",
      valueColor: "#1A77BC",

      fontColor: "#333333",
      img: blue,
      value: "04",
    },
    {
      title: "Customer",
      bgColor: "#F9EBFF",
      borderColor: "#F9EBFF",
      valueColor: "#B832F4",

      fontColor: "#333333",
      img: pink,
      value: "04",
    },
  ];
  const ticketData = [
    {
      title: "New Ticket",
      bgColor: "#FFFFFF",
      borderColor: "#FFFFFF",
      titleColor: "#252563",
      valueColor: "#1A77BC",
      img: blue,
      value: "04",
    },

    {
      title: "Pending Ticket",
      bgColor: "#FFFFFF",
      borderColor: "#FFFFFF",
      valueColor: "#E65100",

      fontColor: "#333333",
      img: orange,
      value: "04",
    },

    {
      title: "Work Completed",
      bgColor: "#FFFFFF",
      borderColor: "#FFFFFF",
      valueColor: "#1A77BC",

      fontColor: "#333333",
      img: blue,
      value: "04",
    },
    {
      title: "Ticket Closed",
      bgColor: "#FFFFFF",
      borderColor: "#FFFFFF",
      valueColor: "#B832F4",

      fontColor: "#333333",
      img: pink,
      value: "04",
    },
  ];
  
   const regionbox = [
    {
      title: "New Ticket",
      bgColor: "#DBF0FF",
      borderColor: "#DBF0FF",
      titleColor: "#252563",
      valueColor: "#1A77BC",
      img: blue,
      value: "04",
    },

    {
      title: "Pending Ticket",
      bgColor: "#FFF4E5",
      borderColor: "#FFF4E5",
      valueColor: "#E65100",

      fontColor: "#333333",
      img: orange,
      value: "04",
    },

    {
      title: "Work Completed",
      bgColor: "#FFF0F3",
      borderColor: "#FFF0F3",
      valueColor: "#C62828",

      fontColor: "#333333",
      img: red,
      value: "04",
    },
    {
      title: "Ticket Closed",
      bgColor: "#E8EAF6",
      borderColor: "#E8EAF6",
      valueColor: "#1A77BC",

      fontColor: "#333333",
      img: blue,
      value: "04",
    },
  ];
  const {
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      CouponType: null,
    },
  });
  const couponOptions = [
     { value: "north1", label: "South 1" },
    { value: "south1", label: "South 2" },
    { value: "east1", label: "South 3" },
    { value: "west1", label: "West Region" },
    { value: "north", label: "North Region" },
    { value: "south", label: "South Region" },
    { value: "east", label: "East Region" },
    { value: "west", label: "West Region" },
  ];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "8px",
      borderColor: "#D9D9D9",
      minHeight: "40px",
      fontSize: "14px",
    }),
  };
  const regionData = [
    { title: "Regional Manager", value: 50, img: person },
    { title: "Service Engineer", value: 35, img: person },
    { title: "Customer", value: 120, img: person },
  ];

  const isViewMode = false;

  return (
    <>
      <Topbar header={"Dashboard"} />
      <div className="container_fluit">
        <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24 px-3 py-3">
          Overall Summary
        </h4>
        <p className="f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20 my-3 px-3 ">
          User List
        </p>

        <div className="row mt-4 px-3 py-3">
          {boxData.map((box, index) => (
            <div
              className="col-sm-1 col-md-2 col-lg-2 mb-3 dashboard-container"
              key={index}
            >
              <div
                className=" text-center  dashboard-title "
                style={{
                  backgroundColor: box.bgColor,
                  border: `1px solid ${box.borderColor}`,
                  color: box.fontColor,
                }}
              >
                <p
                  className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 "
                  style={{ whiteSpace: "normal" }}
                >
                  {box.title}
                </p>
                <div className="d-flex ac-jc gap-2">
                  {box.img && <img src={box.img} alt="icon" height={20} />}
                  <h5
                    className="f3 fs-xs-16 fs-sm-15 fs-md-17 fs-lg-19 fs-xl-22 fs-xxl-24 mb-0"
                    style={{ color: box.valueColor }}
                  >
                    {box.value}
                  </h5>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="ticket_overll pt-4 pb-3 px-3 py-3">
          <p className="f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20 my-3">
            Overall Ticket
          </p>

          <div className="row mt-4 d-flex ac-jb">
            {ticketData.map((box, index) => (
              <div
                className="col-sm-1 col-md-2 col-lg-2 mb-3 dashboard-container"
                key={index}
              >
                <div
                  className=" text-center  dashboard-title "
                  style={{
                    backgroundColor: box.bgColor,
                    border: `1px solid ${box.borderColor}`,
                    color: box.fontColor,
                  }}
                >
                  <p
                    className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 "
                    style={{ whiteSpace: "normal" }}
                  >
                    {box.title}
                  </p>
                  <div className="d-flex ac-jc gap-2">
                    {box.img && <img src={box.img} alt="icon" height={20} />}
                    <h5
                      className="f3 fs-xs-16 fs-sm-15 fs-md-17 fs-lg-19 fs-xl-22 fs-xxl-24 mb-0"
                      style={{ color: box.valueColor }}
                    >
                      {box.value}
                    </h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className=" pt-4 pb-3 px-3 py-3 ">
          <div className="d-flex ac-jb">
            <p className="f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20 my-3">
              Region Based Summary
            </p>
            <div className="col-md-5">
              <Controller
                control={control}
                name="CouponType"
                rules={{ required: "Coupon Type is required" }}
                render={({ field }) => (
                  <div>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Region
                    </label>
                    <Select
                      {...field}
                      options={couponOptions}
                      placeholder="Select Region"
                      isSearchable
                      onChange={field.onChange}
                      value={field.value}
                      styles={customStyles}
                      isDisabled={isViewMode}
                    />
                    {errors.CouponType && (
                      <p style={{ color: "red" }}>
                        {errors.CouponType.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
          </div>
          <div className="d-flex ac-js gap-5 mt-4 ">
            {regionData.map((region, index) => (
              <div
                key={index}
                className="region-card d-flex ac-jc gap-3 p-2  "
              >
                <img src={region.img} height={45} alt={region.title} />
                <div>
                  <h6 className="f1 fs-xs-15 fs-sm-15 fs-md-15 fs-lg-16 fs-xl-17 fs-xxl-19 mb-0">{region.title}</h6>
                  <p className="f2 fs-xs-15 fs-sm-15 fs-md-15 fs-lg-16 fs-xl-17 fs-xxl-19 mb-0">{region.value}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="row mt-4 d-flex ac-jb">
            {regionbox.map((box, index) => (
              <div
                className="col-sm-1 col-md-2 col-lg-2 mb-3 dashboard-container"
                key={index}
              >
                <div
                  className=" text-center  dashboard-title "
                  style={{
                    backgroundColor: box.bgColor,
                    border: `1px solid ${box.borderColor}`,
                    color: box.fontColor,
                  }}
                >
                  <p
                    className=" mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 "
                    style={{ whiteSpace: "normal" }}
                  >
                    {box.title}
                  </p>
                  <div className="d-flex ac-jc gap-2">
                    {box.img && <img src={box.img} alt="icon" height={20} />}
                    <h5
                      className="f3 fs-xs-16 fs-sm-15 fs-md-17 fs-lg-19 fs-xl-22 fs-xxl-24 mb-0"
                      style={{ color: box.valueColor }}
                    >
                      {box.value}
                    </h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
